import 'leaflet/dist/leaflet.css'
import "leaflet-geosearch/assets/css/leaflet.css"
import L from "leaflet"
import * as esri from "esri-leaflet";
import * as shp from "shpjs"
import {GeoSearchControl, OpenStreetMapProvider} from 'leaflet-geosearch';
import wmsLayerFeature from "@/utils/leafletExtensions";
import store from "@/store";


// L.Icon.Default Webpack configuration
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
    iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
    iconUrl: require('leaflet/dist/images/marker-icon.png'),
    shadowUrl: require('leaflet/dist/images/marker-shadow.png')
});


// Leaflet Map is initialised here, because state management does not make sense with leaflet map operations
export let leafletMap;
export let activeLayers;
export let ShapefileLayer;

// Function for Layer initialisation and Layer Actions
const LeafletServices = {

    initMap: function (mapContainerId) {
        leafletMap = L.map(mapContainerId, {zoomControl: false}).setView([51, 12], 6);
        this.addBaseMaps();
        new L.Control.Zoom({position: 'topright'}).addTo(leafletMap);
        this.addSearchBar();

        activeLayers = L.layerGroup().addTo(leafletMap);
        ShapefileLayer = L.featureGroup().addTo(leafletMap);

        leafletMap.attributionControl.addAttribution(' EOMAP GmbH & Co. KG, 2020 | <a href="https://www.eomap.com/exchange/pdf/EOMAP_Terms_Conditions_for_User_of_EOMAP_Products.pdf" target="_blank">Allg. Geschäftsbedingungen</a> | <a href="https://www.eomap.com/legal-information/#privacy-policy" target="_blank">Datenschutzbestimmungen</a>');
    },

    addSearchBar: function () {
        const provider = new OpenStreetMapProvider();
        const searchControl = new GeoSearchControl({
            provider: provider,
            position: "topright",
            searchLabel: 'Adresse eingeben',
            autoClose: true,
            keepResult: true
        });

        leafletMap.addControl(searchControl);
    },

    addBaseMaps: function () {
        const baseMaps = {
            topo: L.tileLayer('https://cartodb-basemaps-{s}.global.ssl.fastly.net/rastertiles/voyager/{z}/{x}/{y}.png', {
                maxZoom: 18,
                attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>,' +
                    ' &copy; <a href="https://carto.com/attribution">CARTO</a>',
            }),
            imagery: esri.basemapLayer("Imagery")
        };

        leafletMap.addLayer(baseMaps.topo);

        const baseMapLabels = {
            "Topographic": baseMaps.topo,
            "Imagery": baseMaps.imagery
        };

        L.control.layers(baseMapLabels).addTo(leafletMap);
    },

    createWmsLeafletLayer: function (service, layer, opacity) {
        let leafletLayer = wmsLayerFeature(service.baseUrl, {
            layers: layer.name,
            format: 'image/png',
            transparent: true,
            opacity: opacity,
            zIndex: 5,
        });

        leafletLayer.service = service.service;
        leafletLayer.title = layer.title;
        leafletLayer.name = layer.name;

        leafletLayer.on("loading", function () {
            store.state.map.layerLoading = true
        });

        leafletLayer.on("load", function () {
            store.state.map.layerLoading = false
        });

        return leafletLayer
    },

    addLayerToMap: function (layer) {
        activeLayers.clearLayers();
        layer.addTo(activeLayers)
    },

    removeAllLayers: function () {
        activeLayers.clearLayers()
    },

    addShapefile: function (ArrayBuffer) {
        shp(ArrayBuffer).then(function (geojson) {
            let layer = L.geoJSON(geojson.features);
            layer.addTo(ShapefileLayer);
            leafletMap.fitBounds(ShapefileLayer.getBounds().pad(0.3))
        });
    },

    removeShapefile: function () {
        ShapefileLayer.clearLayers()
    }
};

export default LeafletServices